<template>
  <v-dialog v-model="dialogEdit" persistent max-width="800px">
      <template v-slot:activator="{}">
      </template>
      <v-card>
        <!-- <v-card-title>
          <span class="headline">{{textTitle}}</span>
        </v-card-title> -->
        <v-card-text>
          <v-container>
            <v-row class="text-right" justify="end">
              <!-- <v-btn class=""><v-icon>mdi-pencil</v-icon></v-btn> -->
              <v-btn
              small
              icon
              color="grey"
              style="background-color: grey"
              @click="dialogEdit = false"
            >
              <v-icon small color="white">mdi-close</v-icon>
            </v-btn>
            <!-- <v-btn class="ma-2 create-orgchart-header-save-btn" tile color="grey" @click="submitData()">
              <v-icon>mdi-close</v-icon>
            </v-btn> -->
            </v-row>
            <v-row class="ml-1" justify="start">
              <v-col cols="2" class="ml-1">
                <!-- <h2 class="txt-head" style="margin-top: 1%">ชื่อเครือบริษัท</h2> -->
                <v-avatar size="">
                  <v-img
                    class="img-border"
                    width="100"
                    height="100"
                    :src="require('@/assets/icons/no_user.png')"
                    aspect-ratio="2.7"
                />
                </v-avatar>
              </v-col>
              <v-col cols="3" class="">
                <h2 class="txt-head" style="margin-top: 30%">แก้ไขเครือบริษัท</h2>
              </v-col>
            </v-row>
              <v-row class="ml-1" justify="end">
                <v-col cols="10" class="form-control text-left">
                  <p class="txt-font" style="margin-top: -3%">ชื่อเครือภาษไทย</p>
                  <v-text-field
                    v-model="groupCompanyname"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                </v-row>
              <div class="form-group" v-for="(input,k) in groupCompany" :key="k" style="text-align: center;">
              <v-row class="ml-1" justify="end">
                <v-col cols="10" class="form-control text-left">
                  <p class="txt-font" style="margin-top: -3%">ชื่อเครือภาษไทย</p>
                  <v-text-field
                    v-model="groupCompany.groupCompanyNameTh"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                </v-row>
                <v-row class="ml-1" justify="end">
                  <v-col cols="10" class="form-control text-left">
                    <p class="txt-font" style="margin-top: -3%">ชื่อเครือภาษาอังกฤษ</p>
                    <v-text-field
                      v-model="groupCompany.groupCompanyNameEng"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn width="18%" class="ma-0" outlined color="success" dark @click="dialogEdit = false">ยกเลิก</v-btn>
          <v-btn width="18%" class="ma-2 mr-5" color="success" dark @click="submitEdit(groupCompany.groupCompanyNameTh, groupCompany.groupCompanyNameEng)">ตกลง</v-btn>
          <!-- <v-btn class="ma-0 create-orgchart-header-cancel-btn" color="red" dark @click="dialogEdit = false">ยกเลิก</v-btn>
          <v-btn class="ma-2 create-orgchart-header-cancel-btn" color="success" dark @click="submitEdit(groupCompany.groupCompanyNameTh, groupCompany.groupCompanyNameEng)">บันทึก</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
export default {
  components: {
  },
  data () {
    return {
      dialogEdit: false,
      textTitle: '',
      preName: '',
      tokenUser: '',
      groupCompanyname: 'INET',
      idGroupCompany: '',
      groupCompany: [{
        groupCompanyNameTh: '',
        groupCompanyNameEng: ''
      }]
    }
  },
  mounted () {
    EventBus.$on('opendialogedit', this.openDialogEdit)
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
  },
  methods: {
    editCompany (value) {
      this.textTitle = ''
      // this.dialogCreate = true
      this.textTitle = value
    },
    add () {
      this.groupCompany.push({
        groupCompanyNameTh: '',
        groupCompanyNameEng: ''
      })
      // console.log(this.groupCompany)
    },
    remove (index) {
      this.groupCompany.splice(index, 1)
    },
    openDialogEdit (value, item) {
      this.groupCompany.groupCompanyNameTh = item.groupCompanyNameTh
      this.groupCompany.groupCompanyNameEng = item.groupCompanyNameEng
      this.idGroupCompany = item._id
      this.dialogEdit = value
    },
    closeDialogCreate () {
      this.dialogCreate = false
      EventBus.$emit('closedialogcreate', this.dialogCreate)
    },
    async submitEdit (nameTh, nameEng) {
      this.preName = ''
      await this.axios({
        method: 'put',
        url: `${this.api}/api/vMonk/groupCompany/` + this.idGroupCompany,
        headers: {
          authorization: this.tokenUser
        },
        data: {
          groupCompanyNameTh: nameTh,
          groupCompanyNameEng: nameEng
        }
      }).then((response) => {
        // swal('Success', 'แก้ไขบริษัท สำเร็จ', 'success')
        swal({
          title: 'สำเร็จ',
          text: 'แก้ไขเครือบริษัทเรียบร้อย',
          icon: require('../../../assets/icons/success-icon.png'),
          button: false,
          timer: 2000,
          closeOnClickOutside: false,
          closeOnEsc: false
        })
        this.groupCompanyNameTh = ''
        this.groupCompanyNameEng = ''
        this.dialogEdit = false
        // location.reload()
        EventBus.$emit('closedialogcreate')
      }).catch(e => {
        console.log(e)
        // swal('Error', 'แก้ไขบริษัท ไม่สำเร็จ', 'error')
        swal({
          title: 'ผิดพลาด',
          text: 'แก้ไขเครือบริษัทไม่สำเร็จ',
          icon: 'error',
          button: true,
          closeOnClickOutside: false,
          closeOnEsc: false
        })
      })
    }
  }
}
</script>
<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
</style>
